import React, { useState, useEffect, Component } from "react";
import {Link} from "react-router-dom"
import csrBanner from "../images/csr-banner.jpg";
import csrStart from "../images/csr-start.png";
import { Pagination, Table } from 'react-bootstrap';
import csr1 from "../images/csr-1.png";
import csr2 from "../images/csr-2.png";
import csr3 from "../images/csr-3.png";
import csr4 from "../images/csr-4.png";
import "./gallery.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import { ApolloClient, HttpLink, InMemoryCache, gql } from "@apollo/client";
import { ApolloProvider } from "@apollo/client/react";
import Footer from "./footer";
import AOS from 'aos';



const client = new ApolloClient({
  link: new HttpLink({ uri: "https://pensure-cms.inspireleadership.biz/graphql"}),
  cache: new InMemoryCache(),
});

const Gallery = () => {

   window.scrollTo(0, 0)

    const [data, setData] = useState([])
    const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 6;

  // Calculate indexes for slicing data
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = data.slice(indexOfFirstItem, indexOfLastItem);

  const totalPages = Math.ceil(data.length / itemsPerPage);

  // Generate pagination items
  let items = [];
  for (let number = 1; number <= totalPages; number++) {
    items.push(
      <Pagination.Item 
        className="ps-2"
        key={number} 
        active={number === currentPage}
        onClick={() => setCurrentPage(number)}
      >
        {number}
      </Pagination.Item>
    );
  }



         useEffect( () => {
                   AOS.init({
                      offset: 0,
                      duration: 1000,
                      once: true
               });
                                
                                    
               }, [])



         useEffect( () => {
    
    client
      .query({
        query: gql`
         query NewQuery {
  pages(first:100) {
    nodes {
      memories {
        images {
          image {
            mediaItemUrl
          }
        }
      }
    }
  }
    }
        `,
      })
      .then((result) => {
    
         console.log(result)
              setData(result.data.pages.nodes[13].memories.images)
   
      });
    
    }, []) 
  

    let imagesDisplay 

    imagesDisplay=  currentItems.map((item, idx) => (
           <div className="galleryBox" style={{ backgroundImage: `url(${item.image.mediaItemUrl})` }} >

           </div>
   

          ))
 window.scrollTo(0, 0)

  return (
    <>
      <div className="containeer pt-4">
        <div
          id="mobile-view"
          className="d-flex justify-space-between pt-5 pb-4"
        >
          <div className=" width-fifty">
            <h2 className="csr-h2 pb-3" data-aos="fade-up" data-aos-delay="200">Our Gallery</h2>
            <p className="grey-p-csr grey-color" data-aos="fade-up" data-aos-delay="200">
              Explore snapshots from our events, CSR drives, and
              behind-the-scenes moments..{" "}
            </p>
          </div>
        </div>

       

     <div
          id="mobile-view"
          className="galleria d-flex align-items-center justify-content-between padding-section-standard-top1"
          data-aos="fade-up" data-aos-delay="200"
        >
          {imagesDisplay}
        </div>
       
       <div className="paginationDiv mx-auto"> 
       <Pagination>
        
        {items}
        <Pagination.Next className="ps-2" onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))} disabled={currentPage === totalPages} />
           </Pagination>
      </div> 
      </div>
           <Footer/>
           <div className='height'> 

              </div>
    </>
  );
};

export default Gallery;
